import { Component, DestroyRef } from "@angular/core";
import { takeUntilDestroyed, toSignal } from "@angular/core/rxjs-interop";
import { NavigationEnd, Router } from "@angular/router";
import { AuthService } from "@core/services/auth/auth.service";
import { BusinessService } from "@data/services/business.service";
import { filter, map } from "rxjs";

@Component({
	selector: "app-base",
	templateUrl: "./base.component.html",
	styleUrls: ["./base.component.scss"],
	standalone: false
})
export class BaseComponent {
	constructor(
		private authService: AuthService,
		private businessService: BusinessService,
		private router: Router,
		private destroyRef: DestroyRef
	) {}

	pageName = "";

	isPublicRoute = toSignal(
		this.router.events.pipe(
			filter((event) => event instanceof NavigationEnd),
			map((event: NavigationEnd) => event.url.startsWith("/public/")),
			takeUntilDestroyed(this.destroyRef)
		),
		{ initialValue: false }
	);

	protected closeMobileSidebar(submenuName: string) {
		this.pageName = submenuName;
	}

	protected isUserSupportAndIsNotLoggedIn(): boolean {
		return (
			!!this.authService.getUserSupport() &&
			!this.authService.isSupportLoggedInAsNormalUser() &&
			this.authService.getRouterEventDone()
		);
	}

	protected canGoToHome(): boolean {
		return this.authService.canGoToHome();
	}

	protected getCompanyName(): string {
		return this.businessService.getBusinessData()?.nomeFantasia ?? "";
	}
}
